<template>
  <DBox
    :id="'cmp-catalog-products-accounts'"
    :addButton="false"
    :addLink="true"
    :addLinkLabel="`${this.$t('add_new')} ${this.$t('account')}`"
    @add_click="addAccountClick"
    :rightMenu="[
      {
        text: $t('get_account'),
        value: 'get_account',
      },
    ]"
    @menuClick="onRightMenuClick"
  >
    <div class="ut-fh">
      <NTable
        class="invcoie-line-list dbox1"
        :headers="headers"
        :items="list"
        :config="tableConfig"
        :id="'accounting-invoices-invoice_line'"
        :showNoItems="false"
        height="170px"
      >
        <template v-slot:item="{ item, tdcon }">
          <tr>
            <td v-bind="tdcon('account_name')">
              <span>{{ item["account_name"] }}</span>
            </td>
            <td v-bind="tdcon('release_date_en')">
              <span>{{ item["release_date"] }}</span>
            </td>
            <td v-bind="tdcon('release_shift_en')">
              <div class="ut-flex">
                <TextField2
                  id="release_shift"
                  class="dbox1"
                  :showLabel="false"
                  :value="item['release_shift']"
                  placeholder="0.00"
                  @blur="(e) => onTextInputBlur(e, 'release_shift', item)"
                  ta="right"
                  style="width: calc(100% - 35px)"
                />
                <span class="ut-colcen" style="min-width: 35px"> {{$t('days')}} </span>
              </div>
            </td>
            <td v-bind="tdcon('exclude')">
              <div class="ut-rowcen">
                <div class="dt-checkbox v2 s1">
                  <input
                    type="checkbox"
                    :name="`exclude-${item['product_account_id']}`"
                    :id="`exclude-${item['product_account_id']}`"
                    :checked="item['exclude_flag'] == '1'"
                    @click="(e) => onProductExclude(e, item)"
                  />
                  <div class="checkmark"></div>
                </div>
              </div>
            </td>
            <td v-bind="tdcon('special_price')">
              <div class="ut-flex">
                <TextField2
                  id="price"
                  class="dbox1"
                  :ta="'right'"
                  :type="'number'"
                  :showLabel="false"
                  :value="item['price']"
                  placeholder="0.00"
                  @blur="(e) => onTextInputBlur(e, 'price', item)"
                  style="width: calc(100% - 35px)"
                />
                <span class="ut-colcen" style="min-width: 35px">
                  {{ item.currency_iso }}
                </span>
              </div>
            </td>
            <td v-bind="tdcon('special_payback')">
              <div class="ut-flex">
                <TextField2
                  id="payback"
                  class="dbox1"
                  :showLabel="false"
                  :value="item['payback']"
                  placeholder="0.00"
                  @blur="(e) => onTextInputBlur(e, 'payback', item)"
                  ta="right"
                  style="width: calc(100% - 35px)"
                />
                <span class="ut-colcen" style="min-width: 35px">
                  {{
                    selectedProductDetails.client &&
                    selectedProductDetails.client.default_currency
                  }}
                </span>
              </div>
            </td>
            <td v-bind="tdcon('options')">
              <div class="dt-icon-container">
                <img
                  src="static/icons/delete.svg"
                  class="dt-icon v5 s1"
                  @click="(e) => onDeleteAccount(item)"
                  :alt="$t('delete_related_contact')"
                  :title="$t('delete_related_contact')"
                />
              </div>
            </td>
          </tr>
        </template>
      </NTable>
    </div>
  </DBox>
</template>

<script>
import { openMailWindow } from "@/utility";
import DBox from "@dtplugins/dbox/dbox";
import NTable from "@/plugins/datatable/datatable";
import TextField from "@plugins/text-field/text-field";

import {
  createNTableConfig,
  createTableHeader,
} from "../../../../plugins/datatable";

export default {
  components: {
    TextField,
    NTable,
    DBox,
  },
  props: {
    selectedProductDetails: {
      required: true,
    },
  },
  data: function () {
    return {
      tableConfig: createNTableConfig({
        headerStyle: 3,
        fullHeight: true,
      }),
    };
  },
  computed: {
    headers: function () {
      return [
        createTableHeader("account_name", { mw:200 }),
        createTableHeader("release_date_en",{ mw:200 }),
        createTableHeader("release_shift_en", {mw:130, ta: "center" }),
        createTableHeader("exclude", { mw:150, ta: "center" }),
        createTableHeader("special_price", { mw:150,ta: "right" }),
        createTableHeader("special_payback", {
          minw:130,
          ta: "right",
        }),
        createTableHeader("options", { text: false, mw: 30, }),
      ];
    },
    list: function () {
      return this.selectedProductDetails.accounts || [];
    },
  },
  methods: {
    onTextInputBlur: function (event, name, item) {
      console.log(event);
      const value = event.value;
      this.$emit("changed", { name, value, item });
    },
    onContactNameClick: function (contact) {
      this.$emit("contact_selected", contact);
    },
    onMail: function (contact) {
      openMailWindow(`mailto: ${contact.email1}`);
    },
    addContactRelationClick: function () {
      this.$router.push({
        ...this.$route,
        query: {
          modal: "add_contact_relation",
          external_id: this.external_id,
          external_table: this.external_table,
        },
      });
    },
    addAccountClick: function () {
      this.$router.push({
        ...this.$route,
        query: {
          modal: "add_product_account",
          external_id: this.selectedProductDetails.product.product_id,
        },
      });
    },
    onDeleteAccount: function (item) {
      this.$emit("delete", item);
    },
    onProductExclude: function (e, item) {
      if (e.target.selected) {
        this.$emit("changed", { name, value, item });
      }
    },

    onRightMenuClick:function(){
      this.$emit("loadAccounts");
    }
    // MARK: Methods
  },
};
</script>

<style lang="scss">
.cmp-catalog-products-accounts {
  .dt-ntable {
    th.exclude {
      span {
        /* margin: 0px 8px; */
      }
    }
  }
}
</style>
